import type { RouteApiWithSearch } from '../types/route-api-with-search'

export type PaginationSearch = {
  page: number
  pageSize: number
}
type RouteApiWithPagination = RouteApiWithSearch<PaginationSearch>

export const usePagination = (routeApi: RouteApiWithPagination) => {
  const { page, pageSize } = routeApi.useSearch()
  const pagination = { pageSize, page }

  const navigate = routeApi.useNavigate()

  const onChangePage = (value: number) => {
    navigate({
      search: previousValue => ({
        ...previousValue,
        page: value
      })
    })
  }

  const onChangePageSize = (value: number) => {
    navigate({
      search: previousValue => ({
        ...previousValue,
        pageSize: value
      })
    })
  }

  return { onChangePage, onChangePageSize, pagination }
}

export type Pagination = ReturnType<typeof usePagination>
